import { render, staticRenderFns } from "./digitalHuman_2d.vue?vue&type=template&id=16100c68&scoped=true"
import script from "./digitalHuman_2d.vue?vue&type=script&lang=js"
export * from "./digitalHuman_2d.vue?vue&type=script&lang=js"
import style0 from "./digitalHuman_2d.vue?vue&type=style&index=0&id=16100c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16100c68",
  null
  
)

export default component.exports